/* eslint-disable camelcase */
import { EnvConfigType, AmplifyConfigType } from './ConfigType';

// dev環境の設定をこちらに追加してください。
// EnvConfigTypeの変更も必要です。

const amplifyConfig: AmplifyConfigType = {
  aws_project_region: 'ap-northeast-1',
  aws_cloud_logic_custom: [
    {
      name: 'PortalAPI',
      endpoint: 'https://saqi4in72l.execute-api.ap-northeast-1.amazonaws.com/dev',
      region: 'ap-northeast-1',
    },
    {
      name: 'BaseAPI',
      endpoint: 'https://oz203mnns3.execute-api.ap-northeast-1.amazonaws.com/dev',
      region: 'ap-northeast-1',
    },
  ],
};

const config: EnvConfigType = {
  env: 'dev',
  amplifyConfig: amplifyConfig,
  logLevel: 'DEBUG',
  analyticsTrackingId: 'G-LVX2Z44SNM',
  inquiryFormUrl: 'about:blank',
  viewerEndpoint: '',
  lpInquiryFormUrl: 'about:blank',
  ymPublishedBibliograpyUrl: 'about:blank',
  siteDomain: 'dev.manabi.poplar.co.jp',
  adminUrl: 'https://admin.dev.manabi.poplar.co.jp',
  yomokkaUrl: 'https://yomokka.dev.manabi.poplar.co.jp',
  sagasokkaUrl: 'https://sagasokka.dev.manabi.poplar.co.jp',
  mottosokkaUrl: 'https://dev.manabi.poplar.co.jp',
  sso: {
    redirectPath: '/loading',
    idpConfig: {
      microsoft: {
        authorizationEndpoint: 'https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize',
        clientId: 'f19bc2e3-0250-4d35-8e25-6c016107116b',
        clientSecret: '', // microsoftでは使用しない
        scope: ['openid', 'profile', 'email', 'User.Read'],
      },
      google: {
        authorizationEndpoint: '', // googleでは使用しない
        clientId: '1019066273342-9abcgfon790etka3nn3mae8mlc306koj.apps.googleusercontent.com',
        clientSecret: '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',
        scope: ['openid', 'profile', 'email'],
      },
    },
  },
  maintenanceInfoUrl: 'https://dev.manabi.poplar.co.jp/maintenance/info.txt',
  maintenanceExpiryUrl: 'https://dev.manabi.poplar.co.jp/maintenance/expiry.txt',
};

export default config;
